import {
  CHAT_LIST_QUERY_KEY,
  CHAT_QUERY_KEY,
} from "@frontend-shared/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { chatApi } from "@/api/services";

export const usePinChat = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (uuid: string) => chatApi.pinChat(uuid),
    onSuccess: (_data, uuid) => {
      queryClient.invalidateQueries({
        queryKey: [CHAT_LIST_QUERY_KEY],
      });
      // NOTE: NSAI-6473 — the open chat's header reads `isPinned` from the
      // chat's own query, not from the list. Left stale, the header keeps
      // offering the previous action, and choosing it toggles the pin back.
      queryClient.invalidateQueries({
        queryKey: [CHAT_QUERY_KEY, uuid],
      });
    },
  });
};
